webpackJsonp([83200411686586],{

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hook-tutorial.c2499352.png";

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _HookTutorial = __webpack_require__(50);
	
	var _HookTutorial2 = _interopRequireDefault(_HookTutorial);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _hookTutorial = __webpack_require__(193);
	
	var _hookTutorial2 = _interopRequireDefault(_hookTutorial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _HookTutorial2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Overview'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Creating your own hooks for Lore is a great way to expand or modify the functionality provided by the framework, and this tutorial will teach you how to do that.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To illustrate the process we\'re going to be using the application below, which displays a list of tweets. In this tutorial, we\'re going to implement a custom hook that provide basic polling behavior (repeatedly making an API call on a given interval) so that we can keep the data in sync across multiple browser tabs as we create and edit tweets.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _hookTutorial2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Ready? Let\'s ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: './step-1/' },
	        'get started'
	      ),
	      '!'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-tutorial-index-js-557deb4f70ebe1c99e44.js